export default __webpack_public_path__ + "PicsRocket.56dc2ba.png";